<!-- =========================================================================================
    File Name: TaskItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 pt-6 pb-10">

        <div class="flex w-full">
            <div class="flex w-full justify-between items-start">
                <div class="mail__details">
                    <h5 class="mb-1 font-semibold">{{ clientName }}</h5>
                    {{ category }}
                </div>

            </div>
        </div>

        <!-- <div class="flex w-full">
            <div class="flex items-center">
            </div>
            <div class="mail__message truncate">
                <span>{{ task.TaskDetails }}</span> 
            </div>
        </div> -->


    </div>
</template>

<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const moment = require('moment') // require


export default {
  components:{
    flatPickr,
    'v-select': vSelect
  },
  props: {
    clientName: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: false
    },
    currentTask:null
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    ProjectList () {
      return this.$store.getters.GetProjectList
    },
    CanClockIn () {
      if (this.currentTask == this.task) {
        return false
      } else {
        return true
      }
    },
    currentTimeEntry () {
      return this.$store.getters.GetCurrentTimeEntry
    }
    
  },
  methods: {
    GetBarPercent (task) {
      const r = task.ActualHours / task.EstimatedHours * 100
      return r
    },
    GetBarColor (percent) {
      if (percent <= 80) {
        return 'success'
      } else if (percent <= 100) {
        return 'warning'
      }
      return 'danger'
    },
    GetProjectCategoryID (projectID) {
      return this.ProjectList.find(x => x.ProjectID == projectID).CategoryID
    },
    ClockIn () {
      if (this.currentTimeEntry == null) {
        const currentTime = moment().format('hh:mm A')
        const currentDate = moment().format('Y-MM-DD')
        console.log(this.task)
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: this.task.Task,
          taskID: this.task.TaskID,
          clientName: this.task.ClientName,
          clientID: this.task.ClientID,
          projectID: this.task.ProjectID,
          categoryID: this.GetProjectCategoryID(this.task.ProjectID),
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: '-',
          endDate: '-',
          description: '',
          error: 'Fields cannot be empty.',
          action: 'clockin', //create, clockin, finish
          mileage: 0,
          sowID: null,
          sowLineItemID: null,
        })
      } else {
        this.$emit('ChildClockIn', this.task)
      }
      
    }
  }
}

</script>

